import { ApolloError, TypedDocumentNode, useSuspenseQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { AnnualOverview, AnnualOverviewQuery, AnnualOverviewQueryVariables } from '../../generated/graphql';
import { NULLABLE_MEASURE_FIELDS } from '../../queries';

export type { AnnualOverview } from '../../generated/graphql';

const query: TypedDocumentNode<AnnualOverviewQuery, AnnualOverviewQueryVariables> = gql`
  query AnnualOverview($marketLocationId: ID!, $year: Int!) {
    annualOverview(marketLocationId: $marketLocationId, year: $year) {
      marketLocationId
      latestFeedDate
      totalForecastedSum {
        ...NullableMeasureFields
      }
      totalForecastedMean {
        ...NullableMeasureFields
      }
      totalMeasurementSum {
        ...NullableMeasureFields
      }
      totalMeasurementMean {
        ...NullableMeasureFields
      }
      totalConsumptionMeasurementSum {
        ...NullableMeasureFields
      }
      totalConsumptionMeasurementMean {
        ...NullableMeasureFields
      }
      totalMeasuredFeedsAtLeast85PercentOfCapacity
      monthlyOverview {
        month
        totalForecasted {
          ...NullableMeasureFields
        }
        meanForecasted {
          ...NullableMeasureFields
        }
        totalMeasurement {
          ...NullableMeasureFields
        }
        meanMeasurement {
          ...NullableMeasureFields
        }
        totalConsumptionMeasurement {
          ...NullableMeasureFields
        }
        meanConsumptionMeasurement {
          ...NullableMeasureFields
        }
        totalMeasuredFeedsAtLeast85PercentOfCapacity
        specificAdditionalRevenue {
          ...NullableMeasureFields
        }
      }
    }
  }
  ${NULLABLE_MEASURE_FIELDS}
`;

export function useAnnualOverview(
  marketLocationId: string,
  year: number,
): [AnnualOverview | undefined, ApolloError | undefined] {
  const { data, error } = useSuspenseQuery(query, { variables: { marketLocationId, year }, errorPolicy: 'all' });

  return [data?.annualOverview, error];
}
